import { Directive, ElementRef, HostListener, OnDestroy, Optional } from '@angular/core';
import { Subscription } from 'rxjs';
import { InputState, InputStateService } from 'services/input-state.service';


const selector = 'textarea:not(.editable-field), input:not(.editable-field), select:not(.editable-field), [inputState]';

@Directive({ selector: selector })
export class InputStateDirective implements OnDestroy {

	private inputStateSubscription?: Subscription;
	private activationSubscription?: Subscription;

	isHover = false;
	 
	constructor(private inputElement: ElementRef<HTMLElement>, @Optional() private inputStateService: InputStateService) {
		if (inputStateService) {
			this.inputStateSubscription = inputStateService.stateChanged.subscribe((state: InputState) => {
				this.isHover = state === InputState.Hover;
				if (state === InputState.Focus) {
					this.inputElement.nativeElement.focus();
				}
				if (state === InputState.Blur) {
					this.inputElement.nativeElement.blur();
				}
			});
			this.activationSubscription = inputStateService.onActivated(() => {
				if (!this.inputElement.nativeElement.matches(selector)) return;
				this.inputElement.nativeElement.focus();
			});
		}
	}

	@HostListener('focus')
	focus() {
		if (!this.inputElement.nativeElement.matches(selector)) return;
		if (this.inputStateService) this.inputStateService.focus();
	}

	@HostListener('blur')
	blur() {
		if (!this.inputElement.nativeElement.matches(selector)) return;
		if (this.inputStateService) this.inputStateService.blur();
	}

	ngOnDestroy(): void {
		if (this.inputStateSubscription) this.inputStateSubscription.unsubscribe();
		if (this.activationSubscription) this.activationSubscription.unsubscribe();
	}
}